
import React, { createContext, useState, useEffect } from "react";

export const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(null);

    useEffect(() => {
        // Fetch the default theme on app load
        fetch("/api/Theme")
            .then((response) => response.json())
            .then((data) => setTheme(data));
    }, []);

    useEffect(() => {
        if (theme) {
            document.documentElement.setAttribute("data-theme", theme.name);
            document.title = theme.title;
        }
    }, [theme]);

    const switchTheme = (themeName) => {
        fetch(`/api/Theme?name=${themeName}`)
            .then((response) => response.json())
            .then((data) => setTheme(data));
    };

    if (!theme) return <div>Loading theme...</div>;

    return (
        <ThemeContext.Provider value={{ theme, switchTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export default ThemeProvider;